import { createAction } from 'redux-actions';
import * as appointmentTypesActions from './actionTypes';
import { get } from '../../services/fetch';

export const getAppointmentTypesRequest = createAction(appointmentTypesActions.GET_APPOINTMENT_TYPES_REQUEST);
export const getAppointmentTypesSuccess = createAction(appointmentTypesActions.GET_APPOINTMENT_TYPES_SUCCESS);
export const getAppointmentTypesFailure = createAction(appointmentTypesActions.GET_APPOINTMENT_TYPES_FAILURE);

// Load-once: the list is fetched at most once per store lifetime. Callers
// (Dashboard, FilterSettingsModal, Configuration) call this on mount and
// never key a refetch on the resulting array — see reducer.js `status`.
export const getAppointmentTypes = () => (dispatch, getState) => {
  const { status } = getState().appointmentTypesReducer;
  if (status === 'loading' || status === 'loaded') return Promise.resolve();

  dispatch(getAppointmentTypesRequest());
  return get(`/v1/appointment-types`)
    .then(res => dispatch(getAppointmentTypesSuccess(res.content)))
    .catch(err => dispatch(getAppointmentTypesFailure(err)));
};
